import $ from 'jquery';
import 'slick-carousel';

export default {
    init() {
        // JavaScript to be fired on the home page
        // Carosello slide storia
        $('.home-storia_carousel').slick({
            autoplay: false,
            dots: true,
            arrows: false,
            prevArrow: $('.slide-prev'),
            nextArrow: $('.slide-next'),
            adaptiveHeight: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    },
    finalize() {

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js